import { RouterItem } from "../interfaces/router-item.interface";

export const routerSidebarItems: RouterItem[] = [
  {
    title: 'SIDEBAR.CUSTOMERS',
    path: '/customers',
    icon: 'fa-users',
  },
  {
    title: 'SIDEBAR.DEACTIVATED_CUSTOMERS',
    path: '/deactivated-customers',
    icon: 'fa-users-slash',
  },
  {
    title: 'SIDEBAR.RULES',
    path: '/rules',
    icon: 'fa-screwdriver-wrench',
    groupToAccess: 'admin_tech'
  },
  {
    title: 'SIDEBAR.SRDISCUSSION',
    path: '/srdiscussion',
    icon: 'fa-comment',
    groupToAccess: 'admin_tech'
  },
  {
    title: 'SIDEBAR.FEATURES',
    path: '/featurecomparison',
    icon: 'fa-scale-balanced',
    groupToAccess: 'admin_tech'
  },
  {
    title: 'SIDEBAR.QUESTIONNAIRE_EDITOR',
    path: '/questionnaire-editor',
    icon: 'fa-clipboard-list',
    groupToAccess: 'admin_tech'
  }
];
